import React, { Component } from 'react';

import classes from './Valuation.module.css';
import bulb from '../../assets/images/bulb.svg';
import correctAnswer from '../../assets/images/correct-answer.svg';
import wrongAnswer from '../../assets/images/wrong-answer.svg';
import previousIcon from '../../assets/images/previousIcon.svg';
// import nextIcon from '../../assets/images/nextIcon.svg';


class Valuation extends Component {
    state = {
        previousChapter: 0,
        nextChapter: 0
    }

    componentDidMount() {
        for (let chapter of this.props.chapters) {
            if (chapter.index === this.props.current) {
                console.log(chapter.index);
                console.log(this.props.chapters.length);
                let prev = chapter.index - 1;
                let next = chapter.index + 1;
                if (prev > 0) {
                    this.setState({ previousChapter: prev });
                }
                if (next <= this.props.chapters.length) {
                    this.setState({ nextChapter: next });
                }
            }

        }
    }
    render() {
        let typeHeadline = this.props.type ? 'Herzlichen Glückwunsch ...' : 'Es tut uns sehr leid ...';
        let typeMessage = "Sie haben die Frage" + (this.props.type ? " richtig " : " falsch ") + "beantwortet!"
        // let continueChapter = this.state.nextChapter > 0 ? <div className={classes.Next} onClick={() => { this.props.click(this.state.nextChapter) }}>
        //     Trotzdem Weiter
        //     <span className={classes.NextIcon} style={{ backgroundImage: `url(${nextIcon})` }}></span>
        // </div> : null;

        return (
            <div className={classes.Valuation}>
                <div className={classes.Modal}>
                    <div className={classes.Bulb} style={{ backgroundImage: `url(${bulb})` }}></div>
                    <img className={classes.FeedbackImg} src={this.props.type ? correctAnswer : wrongAnswer} alt="" />
                    <h2>{typeHeadline}</h2>
                    <p>{typeMessage}</p>
                </div>
                <div className={classes.Choices} >
                    <div className={classes.Previous} onClick={() => { this.props.click(this.state.previousChapter,true,false) }} >
                        <span className={classes.PreviousIcon} style={{ backgroundImage: `url(${previousIcon})` }}></span>
                        Lektion wiederholen
                    </div>
                    <div className={classes.Solution} onClick={() => { this.props.click(this.props.current,false,true) }}>
                        Situation Auflösen
                    </div>
                    {/* {continueChapter} */}
                </div>
            </div>);
    }
}

export default Valuation;